// utils/eventUtils.js

// サンプルイベントデータ
export const sampleEvents = [
  {
      id: 1,
      title: "明治維新",
      startDate: new Date(1868, 0, 3),
      endDate: new Date(1868, 0, 3),
      description:
        "#江戸幕府 が終焉し、#明治政府 が成立。日本の近代化が始まる重要な転換点となった。",
      tags: ["明治維新", "江戸幕府", "明治政府", "日本史", "歴史"],
      position: { x: 0, y: 60 },
    },
    {
      id: 2,
      title: "終戦",
      startDate: new Date(1945, 7, 15),
      endDate: new Date(1945, 7, 15),
      description: "太平洋戦争が終結。日本が連合国に降伏した。",
      tags: ["終戦", "太平洋戦争", "日本史", "歴史"],
      position: { x: 0, y: 60 },
    },
    {
      id: 101,
      title: "バウハウス設立",
      startDate: new Date(1919, 3, 1),
      endDate: new Date(1919, 3, 1),
      description:
        "#モダニズム の原点。#バウハウス は機能美と合理性を追求した芸術学校。",
      tags: ["バウハウス", "モダニズム", "建築教育", "近代建築"],
      position: { x: 0, y: 80 },
    },
    {
      id: 102,
      title: "サヴォア邸",
      startDate: new Date(1931, 0, 1),
      endDate: new Date(1931, 0, 1),
      description: "近代建築の五原則を体現した #ル・コルビュジエ の代表作。",
      tags: ["ル・コルビュジエ", "近代建築", "モダニズム", "住宅建築"],
      position: { x: 0, y: 80 },
    },
    {
      id: 103,
      title: "落水荘",
      startDate: new Date(1939, 0, 1),
      endDate: new Date(1939, 0, 1),
      description: "自然との調和を実現した #有機的建築 の傑作。",
      tags: ["フランク・ロイド・ライト", "有機的建築", "アメリカ建築"],
      position: { x: 0, y: 90 },
    },
    {
      id: 104,
      title: "CIAM設立",
      startDate: new Date(1928, 0, 1),
      endDate: new Date(1928, 0, 1),
      description: "#CIAM は近代建築の国際的普及を目指す会議体。",
      tags: ["CIAM", "都市計画", "近代建築"],
      position: { x: 0, y: 100 },
    },
    {
      id: 105,
      title: "広島平和記念資料館",
      startDate: new Date(1955, 0, 1),
      endDate: new Date(1955, 0, 1),
      description: "#丹下健三 による戦後日本のモダニズム建築。",
      tags: ["丹下健三", "日本建築", "広島", "モダニズム"],
      position: { x: 0, y: 100 },
    },
    {
      id: 106,
      title: "TWAフライトセンター",
      startDate: new Date(1962, 0, 1),
      endDate: new Date(1962, 0, 1),
      description: "曲線的なフォルムが象徴的な #未来派建築 の代表作。",
      tags: ["サーリネン", "空港建築", "未来派建築"],
      position: { x: 0, y: 100 },
    },
    {
      id: 107,
      title: "メタボリズム",
      startDate: new Date(1960, 0, 1),
      endDate: new Date(1960, 0, 1),
      description: "新陳代謝する都市を構想した #メタボリズム 運動。",
      tags: ["メタボリズム", "都市構想", "日本建築"],
      position: { x: 0, y: 110 },
    },
    {
      id: 108,
      title: "大分県立図書館",
      startDate: new Date(1966, 0, 1),
      endDate: new Date(1966, 0, 1),
      description:
        "#磯崎新 初期の代表作。#モダニズム に根ざしつつ独自の構造美を持つ。",
      tags: ["磯崎新", "図書館建築", "日本建築"],
      position: { x: 0, y: 100 },
    },
    {
      id: 109,
      title: "ロイドビル",
      startDate: new Date(1986, 0, 1),
      endDate: new Date(1986, 0, 1),
      description: "#ハイテック建築 の象徴的作品。",
      tags: ["ハイテック建築", "リチャード・ロジャース", "イギリス建築"],
      position: { x: 0, y: 90 },
    },
    {
      id: 110,
      title: "ザハ・ハディド注目を浴びる",
      startDate: new Date(1983, 0, 1),
      endDate: new Date(1983, 0, 1),
      description: "1983年の #香港のピーク・クラブ 計画で国際的注目を浴びた。",
      tags: ["ザハ・ハディド", "女性建築家", "ポストモダン"],
      position: { x: 0, y: 90 },
    },
    {
      id: 111,
      title: "せんだいメディアテーク",
      startDate: new Date(2001, 0, 1),
      endDate: new Date(2001, 0, 1),
      description: "#日本建築 における情報化時代の先駆。",
      tags: ["伊東豊雄", "情報建築", "せんだいメディアテーク"],
      position: { x: 0, y: 100 },
    },
    {
      id: 112,
      title: "テルメ・ヴァルス",
      startDate: new Date(1996, 0, 1),
      endDate: new Date(1996, 0, 1),
      description: "素材と空間体験を重視した #ミニマリズム 建築の傑作。",
      tags: ["ピーター・ズントー", "スイス建築", "ミニマリズム"],
      position: { x: 0, y: 90 },
    },
    {
      id: 113,
      title: "ボルドーの家",
      startDate: new Date(1998, 0, 1),
      endDate: new Date(1998, 0, 1),
      description: "#OMA による可変性のある住宅。",
      tags: ["レム・コールハース", "OMA", "住宅建築"],
      position: { x: 0, y: 100 },
    },
    {
      id: 114,
      title: "東京国立博物館法隆寺宝物館",
      startDate: new Date(1999, 0, 1),
      endDate: new Date(1999, 0, 1),
      description: "静謐で洗練された日本の #現代建築 。",
      tags: ["谷口吉生", "ミュージアム建築", "日本建築"],
      position: { x: 0, y: 95 },
    },
    {
      id: 115,
      title: "光の教会",
      startDate: new Date(1989, 0, 1),
      endDate: new Date(1989, 0, 1),
      description: "#安藤忠雄 による光と空間の宗教建築。",
      tags: ["安藤忠雄", "光の教会", "宗教建築"],
      position: { x: 0, y: 100 },
    },
    {
      id: 116,
      title: "梅田スカイビル",
      startDate: new Date(1993, 0, 1),
      endDate: new Date(1993, 0, 1),
      description: "都市を空中でつなぐ構想を体現した #空中都市 建築。",
      tags: ["原広司", "空中都市", "日本建築"],
      position: { x: 0, y: 90 },
    },
    {
      id: 117,
      title: "中銀カプセルタワー",
      startDate: new Date(1972, 0, 1),
      endDate: new Date(1972, 0, 1),
      description: "#メタボリズム を象徴するカプセル型集合住宅。",
      tags: ["黒川紀章", "中銀カプセルタワー", "集合住宅"],
      position: { x: 0, y: 110 },
    },
    {
      id: 118,
      title: "私の家",
      startDate: new Date(1954, 0, 1),
      endDate: new Date(1954, 0, 1),
      description: "#戦後建築 の代表的な小住宅。",
      tags: ["清家清", "住宅建築", "戦後建築"],
      position: { x: 0, y: 100 },
    },
    {
      id: 119,
      title: "ヴィトラ・デザイン・ミュージアム",
      startDate: new Date(1989, 0, 1),
      endDate: new Date(1989, 0, 1),
      description: "ポストモダンの象徴的なデザインミュージアム。",
      tags: ["フランク・ゲーリー", "ポストモダン", "美術館"],
      position: { x: 0, y: 90 },
    },
    {
      id: 120,
      title: "シアトル図書館",
      startDate: new Date(2004, 0, 1),
      endDate: new Date(2004, 0, 1),
      description: "#レム・コールハース による #情報空間 の実験。",
      tags: ["OMA", "シアトル図書館", "情報空間"],
      position: { x: 0, y: 100 },
    },
    {
    id: 219,
    title: "ギザの大ピラミッド建設",
    startDate: new Date(-2560, 0, 1),
    endDate: new Date(-2560, 0, 1),
    description: "#古代エジプト建築 の金字塔。#クフ王 の墓として建造されたとされる世界最大の石造建築物。",
    tags: ["古代エジプト", "ピラミッド", "クフ王", "世界七不思議"],
    position: { x: 0, y: 50 },
  },
  {
    id: 220,
    title: "パルテノン神殿",
    startDate: new Date(-432, 0, 1),
    endDate: new Date(-432, 0, 1),
    description: "#古代ギリシャ建築 の最高傑作。アテナイのアクロポリスに建設された #ドーリア式 神殿の典型。",
    tags: ["パルテノン神殿", "古代ギリシャ", "ドーリア式", "世界遺産"],
    position: { x: 0, y: 60 },
  },
  {
    id: 221,
    title: "コロッセオ",
    startDate: new Date(80, 0, 1),
    endDate: new Date(80, 0, 1),
    description: "#古代ローマ建築 を代表する円形闘技場。アーチを多用した巨大なコンクリート構造物。",
    tags: ["コロッセオ", "古代ローマ", "円形闘技場", "ローマ建築"],
    position: { x: 0, y: 65 },
  },
  {
    id: 222,
    title: "パンテオン",
    startDate: new Date(128, 0, 1),
    endDate: new Date(128, 0, 1),
    description: "巨大な円形のドームを持つ #古代ローマ の神殿。#ローマン・コンクリート 技術の集大成。",
    tags: ["パンテオン", "古代ローマ", "ドーム建築", "ハドリアヌス帝"],
    position: { x: 0, y: 65 },
  },
  {
    id: 223,
    title: "ハギア・ソフィア大聖堂",
    startDate: new Date(537, 0, 1),
    endDate: new Date(537, 0, 1),
    description: "#ビザンティン建築 の最高傑作。巨大ドームと壮麗なモザイク画で知られる。",
    tags: ["ハギア・ソフィア", "ビザンティン建築", "ドーム", "イスタンブール"],
    position: { x: 0, y: 70 },
  },
  {
    id: 224,
    title: "法隆寺建立",
    startDate: new Date(607, 0, 1),
    endDate: new Date(607, 0, 1),
    description: "現存する世界最古の木造建築群。#飛鳥時代 の建築様式を今に伝える。",
    tags: ["法隆寺", "飛鳥時代", "仏教建築", "日本建築"],
    position: { x: 0, y: 70 },
  },
  {
    id: 225,
    title: "ゴシック様式の誕生",
    startDate: new Date(1144, 0, 1),
    endDate: new Date(1144, 0, 1),
    description: "サン＝ドニ大聖堂の改築が始まり。#リブ・ヴォールト や #ステンドグラス を特徴とする #ゴシック建築 が誕生した。",
    tags: ["ゴシック建築", "サン＝ドニ大聖堂", "中世建築", "フランス"],
    position: { x: 0, y: 75 },
  },
  {
    id: 226,
    title: "アルハンブラ宮殿",
    startDate: new Date(1354, 0, 1),
    endDate: new Date(1354, 0, 1),
    description: "#イスラム建築 の最高峰。精緻な幾何学模様のタイルや stucco（化粧漆喰）装飾が特徴。",
    tags: ["アルハンブラ宮殿", "イスラム建築", "ナスル朝", "スペイン"],
    position: { x: 0, y: 75 },
  },
  {
    id: 227,
    title: "サン・ピエトロ大聖堂着工",
    startDate: new Date(1506, 3, 18),
    endDate: new Date(1506, 3, 18),
    description: "#ブラマンテ の設計で着工。#ミケランジェロ など多くの芸術家が関わった #ルネサンス建築 の集大成。",
    tags: ["サン・ピエトロ大聖堂", "ルネサンス建築", "バチカン", "ミケランジェロ"],
    position: { x: 0, y: 70 },
  },
  {
    id: 228,
    title: "桂離宮",
    startDate: new Date(1662, 0, 1),
    endDate: new Date(1662, 0, 1),
    description: "#数寄屋造り の傑作とされる日本の皇族の別邸。#日本庭園 と建築が一体となった空間。",
    tags: ["桂離宮", "数寄屋造り", "日本庭園", "江戸時代"],
    position: { x: 0, y: 70 },
  },
  {
    id: 229,
    title: "クリスタル・パレス（水晶宮）",
    startDate: new Date(1851, 4, 1),
    endDate: new Date(1851, 4, 1),
    description: "第1回ロンドン万国博覧会の会場。#鉄とガラス で作られたプレファブ建築の先駆け。",
    tags: ["クリスタル・パレス", "ジョセフ・パクストン", "万国博覧会", "近代建築"],
    position: { x: 0, y: 85 },
  },
  {
    id: 230,
    title: "シカゴ派の活動",
    startDate: new Date(1885, 0, 1),
    endDate: new Date(1885, 0, 1),
    description: "シカゴ大火後の復興で活躍した建築家集団。#鉄骨造 の高層ビルを数多く建設し、#モダニズム建築 の礎を築いた。",
    tags: ["シカゴ派", "ルイス・サリヴァン", "高層ビル", "アメリカ建築"],
    position: { x: 0, y: 80 },
  },
  {
    id: 231,
    title: "第1回印象派展",
    startDate: new Date(1874, 3, 15),
    endDate: new Date(1874, 3, 15),
    description: "#クロード・モネ の『#印象・日の出』が名前の由来となり、#印象主義 が誕生した歴史的な展覧会。",
    tags: ["印象派", "クロード・モネ", "近代絵画", "美術史"],
    position: { x: 0, y: 110 },
  },
  {
    id: 232,
    title: "ゴッホ『星月夜』",
    startDate: new Date(1889, 5, 1),
    endDate: new Date(1889, 5, 1),
    description: "#後期印象派 を代表する #フィンセント・ファン・ゴッホ の傑作。力強い筆致と鮮やかな色彩が特徴。",
    tags: ["フィンセント・ファン・ゴッホ", "後期印象派", "星月夜", "近代絵画"],
    position: { x: 0, y: 110 },
  },
  {
    id: 233,
    title: "フォーヴィスム（野獣派）",
    startDate: new Date(1905, 0, 1),
    endDate: new Date(1905, 0, 1),
    description: "#アンリ・マティス を中心とする芸術運動。原色を多用した大胆な色彩表現で画壇に衝撃を与えた。",
    tags: ["フォーヴィスム", "アンリ・マティス", "野獣派", "現代アート"],
    position: { x: 0, y: 115 },
  },
  {
    id: 234,
    title: "ドイツ表現主義「ブリュッケ」結成",
    startDate: new Date(1905, 0, 1),
    endDate: new Date(1905, 0, 1),
    description: "ドレスデンで結成された芸術家グループ。主観的な感情を激しい色彩と形態で表現した。",
    tags: ["ドイツ表現主義", "ブリュッケ", "キルヒナー", "現代アート"],
    position: { x: 0, y: 115 },
  },
  {
    id: 235,
    title: "フランク・ロイド・ライト、プレイリースタイル",
    startDate: new Date(1901, 0, 1),
    endDate: new Date(1910, 0, 1),
    description: "アメリカ中西部の草原（prairie）に由来。水平線を強調したデザインで、#有機的建築 の思想の原点となる。",
    tags: ["フランク・ロイド・ライト", "プレイリースタイル", "有機的建築", "住宅建築"],
    position: { x: 0, y: 90 },
  },
  {
    id: 236,
    title: "AEGタービン工場",
    startDate: new Date(1909, 0, 1),
    endDate: new Date(1909, 0, 1),
    description: "#ペーター・ベーレンス 設計の工場建築。鉄とガラスによる機能的で記念碑的なデザインは、#モダニズム建築 の先駆けとされる。",
    tags: ["ペーター・ベーレンス", "ドイツ工作連盟", "近代建築", "インダストリアルデザイン"],
    position: { x: 0, y: 95 },
  },
  {
    id: 237,
    title: "未来派宣言",
    startDate: new Date(1909, 1, 20),
    endDate: new Date(1909, 1, 20),
    description: "詩人 #マリネッティ が発表。機械、スピード、ダイナミズムを賛美し、伝統的な芸術の破壊を掲げた #アヴァンギャルド 運動。",
    tags: ["未来派", "フトゥリズモ", "マリネッティ", "アヴァンギャルド"],
    position: { x: 0, y: 120 },
  },
  {
    id: 238,
    title: "マルセル・デュシャン『泉』",
    startDate: new Date(1917, 0, 1),
    endDate: new Date(1917, 0, 1),
    description: "既製品の便器にサインをしただけの作品。芸術の概念を根底から問い直した #ダダイズム の象徴。",
    tags: ["マルセル・デュシャン", "ダダイズム", "レディ・メイド", "現代アート"],
    position: { x: 0, y: 120 },
  },
  {
    id: 239,
    title: "コンスタンティノープル遷都",
    startDate: new Date(330, 4, 11),
    endDate: new Date(330, 4, 11),
    description: "コンスタンティヌス1世がローマからビザンティウムへ遷都。#ビザンチン建築 の中心地が誕生した。",
    tags: ["ビザンチン", "古代ローマ", "コンスタンティノープル", "都市計画"],
    position: { x: 0, y: 70 },
  },
  {
    id: 240,
    title: "サン・ヴィターレ聖堂",
    startDate: new Date(547, 0, 1),
    endDate: new Date(547, 0, 1),
    description: "イタリアのラヴェンナにある八角形の集中式聖堂。#ビザンチン美術 の最高傑作とされるモザイク画で有名。",
    tags: ["ビザンチン", "モザイク画", "ラヴェンナ", "初期キリスト教建築"],
    position: { x: 0, y: 70 },
  },
  {
    id: 241,
    title: "聖マルコ大聖堂",
    startDate: new Date(1094, 0, 1),
    endDate: new Date(1094, 0, 1),
    description: "ヴェネツィアに建立。#ビザンチン 様式を基調としながら、多様な文化の影響を受けた独自のスタイルを持つ。",
    tags: ["ビザンチン", "ヴェネツィア", "大聖堂", "ロマネスク"],
    position: { x: 0, y: 75 },
  },
  {
    id: 242,
    title: "クリュニー第三修道院教会",
    startDate: new Date(1088, 0, 1),
    endDate: new Date(1130, 0, 1),
    description: "当時キリスト教世界で最大級の教会堂。#ロマネスク 建築の壮大さを示す代表例だったが、後に大部分が破壊された。",
    tags: ["ロマネスク", "修道院", "クリュニー会", "フランス建築"],
    position: { x: 0, y: 75 },
  },
  {
    id: 243,
    title: "ピサのドゥオモ広場",
    startDate: new Date(1063, 0, 1),
    endDate: new Date(1372, 0, 1),
    description: "大聖堂、洗礼堂、そして有名な鐘楼（#ピサの斜塔）からなる。#ロマネスク 様式の中でも特に華麗なピサ様式の代表。",
    tags: ["ロマネスク", "ピサの斜塔", "イタリア建築", "世界遺産"],
    position: { x: 0, y: 75 },
  },
  {
    id: 244,
    title: "サンティアゴ・デ・コンポステーラ大聖堂",
    startDate: new Date(1075, 0, 1),
    endDate: new Date(1211, 0, 1),
    description: "キリスト教の三大巡礼地の一つ。多くの巡礼者を受け入れるための構造を持つ、#ロマネスク 巡礼教会堂の典型。",
    tags: ["ロマネスク", "巡礼", "スペイン建築", "世界遺産"],
    position: { x: 0, y: 75 },
  },
  {
    id: 245,
    title: "ノートルダム大聖堂 (パリ)",
    startDate: new Date(1163, 0, 1),
    endDate: new Date(1345, 0, 1),
    description: "初期 #ゴシック建築 の代表作。バラ窓やフライング・バットレスの美しさで知られる。",
    tags: ["ゴシック", "ノートルダム大聖堂", "フランス建築", "世界遺産"],
    position: { x: 0, y: 80 },
  },
  {
    id: 246,
    title: "シャルトル大聖堂",
    startDate: new Date(1194, 0, 1),
    endDate: new Date(1220, 0, 1),
    description: "「シャルトル・ブルー」と呼ばれる #ステンドグラス が有名。盛期 #ゴシック の典型的な構成を持つ。",
    tags: ["ゴシック", "ステンドグラス", "フランス建築", "世界遺産"],
    position: { x: 0, y: 80 },
  },
  {
    id: 247,
    title: "ケルン大聖堂",
    startDate: new Date(1248, 0, 1),
    endDate: new Date(1880, 0, 1),
    description: "建設に600年以上を要した巨大な大聖堂。#ゴシック 様式としては世界最大級の規模を誇る。",
    tags: ["ゴシック", "ケルン大聖堂", "ドイツ建築", "世界遺産"],
    position: { x: 0, y: 80 },
  },
  {
    id: 248,
    title: "レオン・バッティスタ・アルベルティ『建築論』",
    startDate: new Date(1452, 0, 1),
    endDate: new Date(1452, 0, 1),
    description: "ウィトルウィウス以来の本格的な建築理論書。#ルネサンス 建築の理論的基礎を築いた。",
    tags: ["ルネサンス", "アルベルティ", "建築理論", "古典主義"],
    position: { x: 0, y: 70 },
  },
  {
    id: 249,
    title: "テンピエット",
    startDate: new Date(1502, 0, 1),
    endDate: new Date(1502, 0, 1),
    description: "#ドナト・ブラマンテ による小礼拝堂。盛期 #ルネサンス 建築の理想を完璧に体現した傑作とされる。",
    tags: ["ルネサンス", "ブラマンテ", "ローマ建築", "古典主義"],
    position: { x: 0, y: 70 },
  },
  {
    id: 250,
    title: "アンドレーア・パッラーディオ『建築四書』",
    startDate: new Date(1570, 0, 1),
    endDate: new Date(1570, 0, 1),
    description: "自らの作品と古代建築の分析をまとめた理論書。後の #パッラーディオ主義 に絶大な影響を与えた。",
    tags: ["ルネサンス", "パッラーディオ", "建築理論", "ヴィチェンツァ"],
    position: { x: 0, y: 70 },
  },
  {
    id: 251,
    title: "サン・ピエトロ広場",
    startDate: new Date(1656, 0, 1),
    endDate: new Date(1667, 0, 1),
    description: "#ジャン・ロレンツォ・ベルニーニ 設計。訪れる人々を両腕で抱擁するかのような楕円形の列柱廊が特徴の #バロック 空間。",
    tags: ["バロック", "ベルニーニ", "広場", "バチカン"],
    position: { x: 0, y: 75 },
  },
  {
    id: 252,
    title: "サン・カルロ・アッレ・クワトロ・フォンターネ聖堂",
    startDate: new Date(1638, 0, 1),
    endDate: new Date(1641, 0, 1),
    description: "#フランチェスコ・ボッロミーニ の代表作。波打つような曲線と複雑な幾何学で構成された独創的な #バロック 建築。",
    tags: ["バロック", "ボッロミーニ", "ローマ建築", "曲線"],
    position: { x: 0, y: 75 },
  },
  {
    id: 253,
    title: "サンスーシ宮殿",
    startDate: new Date(1745, 0, 1),
    endDate: new Date(1747, 0, 1),
    description: "プロイセンのフリードリヒ大王の夏の離宮。「憂いなし」を意味し、#ロココ 様式の繊細さと快適さが追求された。",
    tags: ["ロココ", "フリードリヒ大王", "ドイツ建築", "宮殿"],
    position: { x: 0, y: 80 },
  },
  {
    id: 254,
    title: "ヴィースの巡礼教会",
    startDate: new Date(1745, 0, 1),
    endDate: new Date(1754, 0, 1),
    description: "#ドミニクス・ツィンマーマン 設計。外観は質素だが、内部は光と装飾に満ちた華麗な #ロココ 空間が広がる。",
    tags: ["ロココ", "ドイツ建築", "世界遺産", "教会建築"],
    position: { x: 0, y: 80 },
  },
  {
    id: 255,
    title: "レッド・ハウス",
    startDate: new Date(1859, 0, 1),
    endDate: new Date(1860, 0, 1),
    description: "#ウィリアム・モリス の自邸。建築家 #フィリップ・ウェッブ と共に設計し、#アーツアンドクラフツ 運動の理念を体現した。",
    tags: ["アーツアンドクラフツ", "ウィリアム・モリス", "フィリップ・ウェッブ", "住宅建築"],
    position: { x: 0, y: 85 },
  },
  {
    id: 256,
    title: "ヒル・ハウス",
    startDate: new Date(1902, 0, 1),
    endDate: new Date(1904, 0, 1),
    description: "#チャールズ・レニー・マッキントッシュ の代表作。#アーツアンドクラフツ の影響を受けつつ、独自の幾何学的スタイルを持つ。",
    tags: ["アーツアンドクラフツ", "マッキントッシュ", "グラスゴー派", "スコットランド"],
    position: { x: 0, y: 85 },
  },
  {
    id: 257,
    title: "タッセル邸",
    startDate: new Date(1893, 0, 1),
    endDate: new Date(1893, 0, 1),
    description: "#ヴィクトール・オルタ 設計。有機的な曲線を持つ鉄骨の柱や床のモザイクが特徴で、最初の #アールヌーヴォー 建築とされる。",
    tags: ["アールヌーヴォー", "ヴィクトール・オルタ", "ブリュッセル", "世界遺産"],
    position: { x: 0, y: 90 },
  },
  {
    id: 258,
    title: "パリ・メトロ入口",
    startDate: new Date(1900, 0, 1),
    endDate: new Date(1900, 0, 1),
    description: "#エクトール・ギマール が設計。鋳鉄とガラスによる植物のようなデザインは #アールヌーヴォー の象徴となった。",
    tags: ["アールヌーヴォー", "エクトール・ギマール", "パリ", "公共デザイン"],
    position: { x: 0, y: 90 },
  },
  {
    id: 259,
    title: "カサ・ミラ",
    startDate: new Date(1906, 0, 1),
    endDate: new Date(1912, 0, 1),
    description: "#アントニ・ガウディ 設計の集合住宅。波打つ石のファサードとユニークな屋上の煙突が特徴。",
    tags: ["アールヌーヴォー", "アントニ・ガウディ", "バルセロナ", "世界遺産"],
    position: { x: 0, y: 90 },
  },
  {
    id: 260,
    title: "ウィーン分離派館",
    startDate: new Date(1897, 0, 1),
    endDate: new Date(1898, 0, 1),
    description: "#ヨゼフ・マリア・オルブリッヒ 設計。「時代にはその芸術を、芸術にはその自由を」のスローガンを掲げる #分離派 の活動拠点。",
    tags: ["分離派", "ゼツェッション", "オルブリッヒ", "ウィーン"],
    position: { x: 0, y: 95 },
  },
  {
    id: 261,
    title: "ウィーン郵便貯金局",
    startDate: new Date(1904, 0, 1),
    endDate: new Date(1906, 0, 1),
    description: "#オットー・ワーグナー 設計。装飾を排し、構造や素材の合理性を追求した、#近代建築 への移行を示す重要作。",
    tags: ["分離派", "オットー・ワーグナー", "近代建築", "ウィーン"],
    position: { x: 0, y: 95 },
  },
  {
    id: 262,
    title: "シュトックレー邸",
    startDate: new Date(1905, 0, 1),
    endDate: new Date(1911, 0, 1),
    description: "#ヨーゼフ・ホフマン 設計。#ウィーン工房 が内外装を手掛け、建築・家具・食器までを統合した #総合芸術 作品。",
    tags: ["分離派", "ヨーゼフ・ホフマン", "ウィーン工房", "総合芸術"],
    position: { x: 0, y: 95 },
  },
  {
    id: 263,
    title: "チッタ・ヌオーヴァ（新都市）",
    startDate: new Date(1914, 0, 1),
    endDate: new Date(1914, 0, 1),
    description: "#アントニオ・サンテリア が発表した未来都市のドローイング群。#イタリア未来派 の建築理念を視覚化した。",
    tags: ["イタリア未来派", "アントニオ・サンテリア", "都市構想", "ドローイング"],
    position: { x: 0, y: 110 },
  },
  {
    id: 264,
    title: "リンゴット工場",
    startDate: new Date(1923, 0, 1),
    endDate: new Date(1923, 0, 1),
    description: "フィアット社の巨大工場。屋上に自動車のテストコースを持つ構造は、#イタリア未来派 が称賛した機械文明とスピードを象徴する。",
    tags: ["イタリア未来派", "工場建築", "トリノ", "近代建築"],
    position: { x: 0, y: 110 },
  },
  {
    id: 265,
    title: "エル・リシツキー『プロウン』",
    startDate: new Date(1919, 0, 1),
    endDate: new Date(1920, 0, 1),
    description: "「新しいものの確立のためのプロジェクト」の略。絵画から建築への移行を目指した #構成主義 の実験的な空間構成。",
    tags: ["構成主義", "エル・リシツキー", "ロシア・アヴァンギャルド", "抽象芸術"],
    position: { x: 0, y: 115 },
  },
  {
    id: 266,
    title: "ルサコフ労働者クラブ",
    startDate: new Date(1927, 0, 1),
    endDate: new Date(1929, 0, 1),
    description: "#コンスタンチン・メーリニコフ 設計。観客席が外部に突き出したダイナミックな形態を持つ #構成主義 建築の傑作。",
    tags: ["構成主義", "メーリニコフ", "ロシア・アヴァンギャルド", "モスクワ"],
    position: { x: 0, y: 115 },
  },
  {
    id: 267,
    title: "デッサウのバウハウス校舎",
    startDate: new Date(1925, 0, 1),
    endDate: new Date(1926, 0, 1),
    description: "#ヴァルター・グロピウス 設計。鉄とガラスのカーテンウォールが特徴。#バウハウス の理念と #モダニズム 建築の principles を体現。",
    tags: ["バウハウス", "ヴァルター・グロピウス", "モダニズム", "ドイツ建築"],
    position: { x: 0, y: 100 },
  },
  {
    id: 268,
    title: "バルセロナ・パビリオン",
    startDate: new Date(1929, 0, 1),
    endDate: new Date(1929, 0, 1),
    description: "#ミース・ファン・デル・ローエ 設計。水平・垂直の線と最小限の要素で構成された #モダニズム 空間の傑作。",
    tags: ["バウハウス", "ミース・ファン・デル・ローエ", "モダニズム", "レス・イズ・モア"],
    position: { x: 0, y: 100 },
  },
  {
    id: 269,
    title: "バウハウス閉校",
    startDate: new Date(1933, 7, 1),
    endDate: new Date(1933, 7, 1),
    description: "ナチスからの圧力により閉校を余儀なくされる。多くの関係者がアメリカなどに亡命し、#バウハウス の理念を世界に広めた。",
    tags: ["バウハウス", "ナチス", "モダニズム", "デザイン教育"],
    position: { x: 0, y: 100 },
  },
  {
    id: 270,
    title: "クライスラー・ビルディング",
    startDate: new Date(1930, 4, 27),
    endDate: new Date(1930, 4, 27),
    description: "#ウィリアム・ヴァン・アレン 設計。ステンレス鋼の鱗模様の尖塔が特徴的な #アールデコ 様式の摩天楼の象徴。",
    tags: ["アールデコ", "摩天楼", "ニューヨーク", "アメリカ建築"],
    position: { x: 0, y: 90 },
  },
  {
    id: 271,
    title: "エンパイア・ステート・ビルディング",
    startDate: new Date(1931, 4, 1),
    endDate: new Date(1931, 4, 1),
    description: "長年にわたり世界一の高さを誇った摩天楼。#アールデコ の様式をよりシンプルかつ力強く表現している。",
    tags: ["アールデコ", "摩天楼", "ニューヨーク", "世界一"],
    position: { x: 0, y: 90 },
  },
  {
    id: 272,
    title: "ユニテ・ダビタシオン",
    startDate: new Date(1952, 0, 1),
    endDate: new Date(1952, 0, 1),
    description: "#ル・コルビュジエ 設計の集合住宅。「輝く都市」構想を具現化したもので、#ブルータリズム の起源ともされる。",
    tags: ["モダニズム", "ル・コルビュジエ", "集合住宅", "ブルータリズム"],
    position: { x: 0, y: 105 },
  },
  {
    id: 273,
    title: "シーグラム・ビルディング",
    startDate: new Date(1958, 0, 1),
    endDate: new Date(1958, 0, 1),
    description: "#ミース・ファン・デル・ローエ 設計。均質なガラスのカーテンウォールを持つ、#モダニズム 超高層ビルの完成形。",
    tags: ["モダニズム", "ミース・ファン・デル・ローエ", "インターナショナル・スタイル", "ニューヨーク"],
    position: { x: 0, y: 105 },
  },
  {
    id: 274,
    title: "ブラジリア計画",
    startDate: new Date(1956, 0, 1),
    endDate: new Date(1960, 0, 1),
    description: "#ルシオ・コスタ と #オスカー・ニーマイヤー による新首都計画。#モダニズム の理念に基づいた壮大な都市・建築群。",
    tags: ["モダニズム", "オスカー・ニーマイヤー", "都市計画", "ブラジル"],
    position: { x: 0, y: 105 },
  },
  {
    id: 275,
    title: "ボストン市庁舎",
    startDate: new Date(1968, 0, 1),
    endDate: new Date(1968, 0, 1),
    description: "#コールマン・マッキネル・アンド・ウッド 設計。記念碑的で彫刻的な形態を持つ、アメリカの #ブルータリズム 建築の代表例。",
    tags: ["ブルータリズム", "アメリカ建築", "公共建築", "ボストン"],
    position: { x: 0, y: 110 },
  },
  {
    id: 276,
    title: "トレリック・タワー",
    startDate: new Date(1972, 0, 1),
    endDate: new Date(1972, 0, 1),
    description: "#エルノ・ゴールドフィンガー 設計。設備系統を収めたサービス・タワーが分離した特徴的な形態を持つ集合住宅。",
    tags: ["ブルータリズム", "集合住宅", "ロンドン", "イギリス建築"],
    position: { x: 0, y: 110 },
  },
  {
    id: 277,
    title: "母の家 (ヴェンチューリ自邸)",
    startDate: new Date(1964, 0, 1),
    endDate: new Date(1964, 0, 1),
    description: "#ロバート・ヴェンチューリ 設計。「少ないことは退屈だ(Less is a bore)」を掲げ、#ポストモダニズム の幕開けを告げた住宅。",
    tags: ["ポストモダニズム", "ロバート・ヴェンチューリ", "住宅建築", "建築理論"],
    position: { x: 0, y: 95 },
  },
  {
    id: 278,
    title: "AT&Tビル (現ソニービル)",
    startDate: new Date(1984, 0, 1),
    endDate: new Date(1984, 0, 1),
    description: "#フィリップ・ジョンソン 設計。頂部に古典的なペディメント（破風）を頂くデザインで、#ポストモダニズム の象徴となる。",
    tags: ["ポストモダニズム", "フィリップ・ジョンソン", "摩天楼", "ニューヨーク"],
    position: { x: 0, y: 95 },
  },
  {
    id: 279,
    title: "つくばセンタービル",
    startDate: new Date(1983, 0, 1),
    endDate: new Date(1983, 0, 1),
    description: "#磯崎新 設計。西洋の広場や建築を引用・コラージュした、日本の #ポストモダニズム 建築を代表する作品。",
    tags: ["ポストモダニズム", "磯崎新", "日本建築", "つくば"],
    position: { x: 0, y: 95 },
  },
  {
    id: 280,
    title: "ヴィトラ消防署",
    startDate: new Date(1993, 0, 1),
    endDate: new Date(1993, 0, 1),
    description: "#ザハ・ハディド の初期の代表作。傾いた壁や鋭角的な形態が特徴の #デコン 建築。",
    tags: ["デコン", "ザハ・ハディド", "ヴィトラ", "ドイツ建築"],
    position: { x: 0, y: 100 },
  },
  {
    id: 281,
    title: "ユダヤ博物館 (ベルリン)",
    startDate: new Date(1999, 0, 1),
    endDate: new Date(1999, 0, 1),
    description: "#ダニエル・リベスキンド 設計。ジグザグの平面計画や断絶した空間で、ユダヤ人の歴史を象徴的に表現。",
    tags: ["デコン", "ダニエル・リベスキンド", "博物館", "ベルリン"],
    position: { x: 0, y: 100 },
  },
  {
    id: 282,
    title: "スコラ学の確立",
    startDate: new Date(1274, 0, 1),
    endDate: new Date(1274, 0, 1),
    description: "#トマス・アクィナス が『#神学大全』を完成。論理的・体系的な思考は、#ゴシック 建築の構造的な合理性と精神的な背景を共有する。",
    tags: ["ゴシック", "哲学", "スコラ学", "中世", "思想史"],
    position: { x: 0, y: 80 },
  },
  {
    id: 283,
    title: "活版印刷技術の発明",
    startDate: new Date(1450, 0, 1),
    endDate: new Date(1450, 0, 1),
    description: "#グーテンベルク による活版印刷が、古典文献や科学知識の普及を加速させ、#ルネサンス の人文主義を支える技術的基盤となった。",
    tags: ["ルネサンス", "技術史", "グーテンベルク", "人文主義", "社会史"],
    position: { x: 0, y: 70 },
  },
  {
    id: 284,
    title: "レオナルド・ダ・ヴィンチ『モナ・リザ』制作",
    startDate: new Date(1503, 0, 1),
    endDate: new Date(1506, 0, 1),
    description: "盛期 #ルネサンス を象徴する絵画。人間への深い洞察と科学的な探究心が結実した、#人文主義 芸術の頂点。",
    tags: ["ルネサンス", "美術史", "レオナルド・ダ・ヴィンチ", "絵画", "人文主義"],
    position: { x: 0, y: 70 },
  },
  {
    id: 285,
    title: "対抗宗教改革",
    startDate: new Date(1545, 0, 1),
    endDate: new Date(1563, 0, 1),
    description: "カトリック教会がプロテスタントに対抗。人々を魅了し、信仰心を高めるため、#バロック の劇的で感情に訴える芸術様式が奨励された。",
    tags: ["バロック", "思想史", "宗教改革", "社会史"],
    position: { x: 0, y: 75 },
  },
  {
    id: 286,
    title: "啓蒙思想の隆盛",
    startDate: new Date(1751, 0, 1),
    endDate: new Date(1772, 0, 1),
    description: "#百科全書 の編纂など、理性を重んじる #啓蒙思想 が広まる。貴族社会の洗練されたサロン文化の中で、優美な #ロココ 様式が育まれた。",
    tags: ["ロココ", "哲学", "啓蒙思想", "思想史", "百科全書"],
    position: { x: 0, y: 80 },
  },
  {
    id: 287,
    title: "ジョン・ラスキンの思想",
    startDate: new Date(1849, 0, 1),
    endDate: new Date(1849, 0, 1),
    description: "『建築の七燈』などを通じ、産業社会を批判し、中世の職人仕事の道徳性を称揚。#アーツアンドクラフツ 運動に思想的な影響を与えた。",
    tags: ["アーツアンドクラフツ", "思想史", "ジョン・ラスキン", "社会批評"],
    position: { x: 0, y: 85 },
  },
  {
    id: 288,
    title: "アルフォンス・ミュシャのポスター",
    startDate: new Date(1895, 0, 1),
    endDate: new Date(1895, 0, 1),
    description: "女優サラ・ベルナールのためのポスターが大成功。#アールヌーヴォー のグラフィックデザインを代表する存在となる。",
    tags: ["アールヌーヴォー", "美術史", "ミュシャ", "ポスター", "グラフィックデザイン"],
    position: { x: 0, y: 90 },
  },
  {
    id: 289,
    title: "ジークムント・フロイト『夢判断』",
    startDate: new Date(1899, 11, 1),
    endDate: new Date(1899, 11, 1),
    description: "精神分析学を創始し、人間の無意識の領域を探求。世紀末ウィーンの知性を象徴し、#分離派 などが探求した内面性と共振する。",
    tags: ["分離派", "思想史", "フロイト", "精神分析学", "世紀末"],
    position: { x: 0, y: 95 },
  },
  {
    id: 290,
    title: "ボッチョーニ『空間における連続性の唯一の形態』",
    startDate: new Date(1913, 0, 1),
    endDate: new Date(1913, 0, 1),
    description: "運動のダイナミズムを捉えようとした #イタリア未来派 の彫刻の傑作。機械時代のスピードと力を賛美する思想を体現。",
    tags: ["イタリア未来派", "美術史", "ボッチョーニ", "彫刻", "モダニズム"],
    position: { x: 0, y: 110 },
  },
  {
    id: 291,
    title: "ロシア革命",
    startDate: new Date(1917, 10, 1),
    endDate: new Date(1917, 10, 1),
    description: "社会体制が劇的に変化し、新しい社会の建設を目指す機運が高まる。#構成主義 は、この革命の理想を芸術で実現しようとした。",
    tags: ["構成主義", "社会史", "ロシア革命", "ロシア・アヴァンギャルド"],
    position: { x: 0, y: 115 },
  },
  {
    id: 292,
    title: "マルセル・ブロイヤー「ワシリーチェア」",
    startDate: new Date(1925, 0, 1),
    endDate: new Date(1925, 0, 1),
    description: "スチールパイプを用いた革命的な椅子。#バウハウス の工房から生まれた、新しい素材と生産方法を探求する精神の象徴。",
    tags: ["バウハウス", "デザイン史", "家具デザイン", "モダニズム", "ワシリーチェア"],
    position: { x: 0, y: 100 },
  },
  {
    id: 293,
    title: "ツタンカーメン王墓の発見",
    startDate: new Date(1922, 11, 4),
    endDate: new Date(1922, 11, 4),
    description: "古代エジプトの装飾が欧米で大流行（エジプトマニア）。その直線的・幾何学的なモチーフは #アールデコ のデザインに多大な影響を与えた。",
    tags: ["アールデコ", "社会史", "流行", "エジプト", "デザイン史"],
    position: { x: 0, y: 90 },
  },
  {
    id: 294,
    title: "ピート・モンドリアンと新造形主義",
    startDate: new Date(1920, 0, 1),
    endDate: new Date(1920, 0, 1),
    description: "水平・垂直線と三原色による究極の抽象絵画。#デ・ステイル 運動の中心として、#モダニズム の理念を純粋な形で追求した。",
    tags: ["モダニズム", "美術史", "モンドリアン", "デ・ステイル", "抽象絵画"],
    position: { x: 0, y: 105 },
  },
  {
    id: 295,
    title: "第二次大戦後の福祉国家",
    startDate: new Date(1945, 0, 1),
    endDate: new Date(1960, 0, 1),
    description: "戦後の復興と社会保障の拡充のため、多くの公共建築（公営住宅、学校、庁舎）が建設された。#ブルータリズム はその際の経済的・倫理的な要求に応える様式として採用された。",
    tags: ["ブルータリズム", "社会史", "戦後復興", "公共建築", "福祉国家"],
    position: { x: 0, y: 110 },
  },
  {
    id: 296,
    title: "アンディ・ウォーホルとポップアート",
    startDate: new Date(1962, 0, 1),
    endDate: new Date(1962, 0, 1),
    description: "大量生産・大量消費社会のイメージを主題とし、芸術と大衆文化の境界を曖昧にした。#ポストモダニズム の「引用」や「大衆性」と通底する。",
    tags: ["ポストモダニズム", "美術史", "ポップアート", "アンディ・ウォーホル", "現代アート"],
    position: { x: 0, y: 95 },
  },
  {
    id: 297,
    title: "ジャック・デリダと脱構築",
    startDate: new Date(1967, 0, 1),
    endDate: new Date(1967, 0, 1),
    description: "西洋哲学の二項対立的な構造を解体・再構築しようとする #脱構築 の思想を提唱。建築における #デコンストラクション の理論的支柱となった。",
    tags: ["デコン", "哲学", "デリダ", "ポスト構造主義", "思想史"],
    position: { x: 0, y: 100 },
  },
];

// 初期タグ
export const initialTags = [
  "明治維新", "江戸幕府", "明治政府", "終戦", "太平洋戦争",
  "日本史", "歴史", "政治", "文化", "モダニズム", "近代建築"
];